/**
 * Defines the rest product module
 */
ixModuleRouting("impactx.restproduct", {
    '/restproductlist': {
        template: '<ixa-rest-product-list></ixa-rest-product-list>',
        process: 'RestProduct',
        workspace: 'content',
    },
    '/restproduct/:id': {
        template: '<ixa-rest-product-dialog></ixa-rest-product-dialog>',
        process: 'RestProduct',
        workspace: 'content',
    },
    '/restproductamountlist': {
        template: '<ixa-rest-product-amount-list></ixa-rest-product-amount-list>',
        process: 'RestProductAmount',
        workspace: 'shop',
    },
    '/restproductamount/:id': {
        template: '<ixa-rest-product-amount-dialog></ixa-rest-product-amount-dialog>',
        process: 'RestProductAmount',
        workspace: 'shop',
    },
});
